import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

export interface AuthState {
  isLoggedIn?: boolean;
  id?: number;
  username?: string;
  email?: string;
  roles?: string[];
  openmrsRoles?: Array<{ uuid: string; display: string; name: string }>;
  indiCid?: string;
  indicPassword?: string;
  parentLocation: string;
  accessToken?: string;
  tokenType?: string;
  providerUuid?: string;
  personUuid?: string;
  authenticated: boolean;
  priviliges?: Array<{ uuid: string; display: string; name: string }>;
  isSuperAdmin?: boolean;
  isDoctor?: boolean;
  isNonMedicalClinical?: boolean;
  isStaff?: boolean;
  defaultPage?: string;
  // isClinicProvider combines both doctor and non medical clinical person
  isClinicalProvider?: boolean;
  isPsychologist?: boolean;
}

const { persistAtom: persistAuthAtom } = recoilPersist({
  key: 'authPersist',
  storage: window.localStorage,
});

export const authAtom = atom<AuthState>({
  key: 'auth',
  default: {
    isLoggedIn: false,
    id: undefined,
    username: '',
    email: '',
    roles: [],
    indiCid: '',
    indicPassword: '',
    parentLocation: '',
    accessToken: '',
    tokenType: 'Bearer',
    providerUuid: '',
    personUuid: '',
    authenticated: false,
    priviliges: [],
    isSuperAdmin: false,
    defaultPage: '',
    isPsychologist: false,
  },
  effects_UNSTABLE: [persistAuthAtom],
});
